import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import * as d3 from 'd3';

import HoverOver from '../HoverOver';
import LineChartGrid from "./LineChartGrid";

import './LineChart.css';

class LineChart extends Component {

  constructor(props) {
    super(props);

    this.state = {
      margin: {left: 40, right: 30, top: 30, bottom: 30},
      width: 500,
      height: props.height || 340
    };
  }

  componentDidMount() {
    this.handelResize(this.refs.wrapper.offsetWidth)
  }

  handelResize(width = 500) {
    this.setState({width: width, height: this.props.height || Math.min(340, width * .85)});
  }

  render() {
    return (
      <div ref="wrapper" className="LineChart" height={this.state.height}>
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <LineChartGrid
          margin={this.state.margin}
          width={this.state.width}
          height={this.state.height}
          titleY={this.props.titleY}
          dimY={this.props.dimY}
          dimG={this.props.dimG}
          year={this.props.year}
          type={this.props.type}
          selected={this.props.selected}
          data={this.props.data}
          onHoverOver={(fips, hover) => {
            this.setState({hover});
            d3.selectAll("#FIPS_" + fips).attr("class", "hover_over");
          }}
          onHoverOut={fips => {
            this.setState({hover: null});
            d3.selectAll("#FIPS_" + fips).attr("class", "hover_out");
          }}
          onClick={(fips, year) => {
            if (this.props.onClick) {
              this.props.onClick(fips, year);
            }
          }}
        />
        <HoverOver data={this.state.hover} {...this.state.margin}/>
      </div>
    );
  }
}

LineChart.propTypes = {
  type: PropTypes.string,
  dimG: PropTypes.string,
  dimY: PropTypes.string,
  titleY: PropTypes.string,
  year: PropTypes.number,
  data: PropTypes.array,
  selected: PropTypes.number,
  onClick: PropTypes.func
};

export default LineChart;




// WEBPACK FOOTER //
// ./src/charts/LineChart/index.js